import Dispatch from "nexia_mobile/flux_like/dispatch";
import { addMessage } from "nexia_mobile/components/Toaster";

Dispatch.on("SHOW_TOAST", (message) => {
  addMessage(message);
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/toaster.js